/* ============================================================================
   THE FUEL PLACE · Selector de despacho — LÓGICA
   ----------------------------------------------------------------------------
   - JS vanilla puro, cero dependencias, cero scripts inline.
   - El trigger y el modal pueden vivir en partes DISTINTAS del DOM: este
     script los encuentra por id, no asume que estén juntos.
   - Integración con Daffl (CarrierService) intacta: endpoint, header
     X-Shopify-Shop-Domain, parseo de rates, fallback por región.
   - Persistencia en localStorage (con respaldo en memoria si está bloqueado).

   IDs que espera en el DOM:
     Trigger:  #tfp-ship-trigger, #tfp-trigger-label, #tfp-trigger-main
     Modal:    #tfp-ship-modal (backdrop), #tfp-ship-close, #tfp-ship-title,
               #tfp-region, #tfp-comuna, #tfp-ship-calc, #tfp-calc-text,
               #tfp-ship-error, #tfp-ship-result, #tfp-result-flags,
               #tfp-ship-despachos (filas dinámicas)
   ============================================================================ */
(function () {
  "use strict";

  /* ---------------------------------------------------------------
     CONFIG
  --------------------------------------------------------------- */
  var ENDPOINT = "https://southamerica-east1-daffl-production.cloudfunctions.net/shopifyCallback/rates";
  var SHOP_DOMAIN = "85bf65-cf.myshopify.com";
  var TIMEOUT_MS = 6000;
  var LS_KEY = "tfp_ship_v1";

  /* ---------------------------------------------------------------
     REGIONES (código ISO) — RM siempre primera, resto A–Z
  --------------------------------------------------------------- */
  var REGIONS = [
    { code: "RM", name: "Región Metropolitana" },
    { code: "AN", name: "Antofagasta" },
    { code: "AR", name: "La Araucanía" },
    { code: "AP", name: "Arica y Parinacota" },
    { code: "AT", name: "Atacama" },
    { code: "AI", name: "Aysén" },
    { code: "BI", name: "Biobío" },
    { code: "CO", name: "Coquimbo" },
    { code: "LR", name: "Los Ríos" },
    { code: "LL", name: "Los Lagos" },
    { code: "MA", name: "Magallanes" },
    { code: "ML", name: "Maule" },
    { code: "NB", name: "Ñuble" },
    { code: "LI", name: "O'Higgins" },
    { code: "TA", name: "Tarapacá" },
    { code: "VS", name: "Valparaíso" }
  ];

  /* ---------------------------------------------------------------
     COMUNAS por región (oficial, se ordena A–Z al renderizar)
  --------------------------------------------------------------- */
  var COMUNAS = {
    RM: ["Alhué","Buin","Calera de Tango","Cerrillos","Cerro Navia","Colina","Conchalí","Curacaví","El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla de Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Lampa","Las Condes","Lo Barnechea","Lo Espejo","Lo Prado","Macul","Maipú","María Pinto","Melipilla","Ñuñoa","Padre Hurtado","Paine","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquín","San José de Maipo","San Miguel","San Pedro","San Ramón","Santiago","Talagante","Tiltil","Vitacura"],
    AP: ["Arica","Camarones","General Lagos","Putre"],
    TA: ["Alto Hospicio","Camiña","Colchane","Huara","Iquique","Pica","Pozo Almonte"],
    AN: ["Antofagasta","Calama","María Elena","Mejillones","Ollagüe","San Pedro de Atacama","Sierra Gorda","Taltal","Tocopilla"],
    AT: ["Alto del Carmen","Caldera","Chañaral","Copiapó","Diego de Almagro","Freirina","Huasco","Tierra Amarilla","Vallenar"],
    CO: ["Andacollo","Canela","Combarbalá","Coquimbo","Illapel","La Higuera","La Serena","Los Vilos","Monte Patria","Ovalle","Paihuano","Punitaqui","Río Hurtado","Salamanca","Vicuña"],
    VS: ["Algarrobo","Cabildo","Calle Larga","Cartagena","Casablanca","Catemu","Concón","El Quisco","El Tabo","Hijuelas","Isla de Pascua","Juan Fernández","La Calera","La Cruz","La Ligua","Limache","Llay-Llay","Los Andes","Nogales","Olmué","Panquehue","Papudo","Petorca","Puchuncaví","Putaendo","Quillota","Quilpué","Quintero","Rinconada","San Antonio","San Esteban","San Felipe","Santa María","Santo Domingo","Valparaíso","Villa Alemana","Viña del Mar","Zapallar"],
    LI: ["Chépica","Chimbarongo","Codegua","Coínco","Coltauco","Doñihue","Graneros","La Estrella","Las Cabras","Litueche","Lolol","Machalí","Malloa","Marchihue","Mostazal","Nancagua","Navidad","Olivar","Palmilla","Paredones","Pelequén","Peralillo","Peumo","Pichidegua","Pichilemu","Placilla","Pumanque","Quinta de Tilcoco","Rancagua","Rengo","Requínoa","San Fernando","San Vicente","Santa Cruz"],
    ML: ["Cauquenes","Chanco","Colbún","Constitución","Curepto","Curicó","Empedrado","Hualañé","Licantén","Linares","Longaví","Maule","Molina","Parral","Pelarco","Pelluhue","Pencahue","Rauco","Retiro","Río Claro","Romeral","Sagrada Familia","San Clemente","San Javier","San Rafael","Talca","Teno","Vichuquén","Villa Alegre","Yerbas Buenas"],
    NB: ["Bulnes","Chillán","Chillán Viejo","Cobquecura","Coelemu","Coihueco","El Carmen","Ninhue","Ñiquén","Pemuco","Pinto","Portezuelo","Quillón","Quirihue","Ránquil","San Carlos","San Fabián","San Ignacio","San Nicolás","Treguaco","Yungay"],
    BI: ["Alto Biobío","Antuco","Arauco","Cabrero","Cañete","Chiguayante","Concepción","Contulmo","Coronel","Curanilahue","Florida","Hualpén","Hualqui","Laja","Lebu","Los Álamos","Los Ángeles","Lota","Mulchén","Nacimiento","Negrete","Penco","Quilaco","Quilleco","San Pedro de la Paz","San Rosendo","Santa Bárbara","Santa Juana","Talcahuano","Tirúa","Tomé","Tucapel","Yumbel"],
    AR: ["Angol","Carahue","Cholchol","Collipulli","Cunco","Curacautín","Curarrehue","Ercilla","Freire","Galvarino","Gorbea","Lautaro","Loncoche","Lonquimay","Los Sauces","Lumaco","Melipeuco","Nueva Imperial","Padre Las Casas","Perquenco","Pitrufquén","Pucón","Purén","Renaico","Saavedra","Temuco","Teodoro Schmidt","Toltén","Traiguén","Victoria","Vilcún","Villarrica"],
    LR: ["Corral","Futrono","La Unión","Lago Ranco","Lanco","Los Lagos","Máfil","Mariquina","Paillaco","Panguipulli","Río Bueno","Valdivia"],
    LL: ["Ancud","Calbuco","Castro","Chaitén","Chonchi","Cochamó","Curaco de Vélez","Dalcahue","Fresia","Frutillar","Futaleufú","Hualaihué","Llanquihue","Los Muermos","Maullín","Osorno","Palena","Puerto Montt","Puerto Octay","Puerto Varas","Puqueldón","Purranque","Puyehue","Queilén","Quellón","Quemchi","Quinchao","Río Negro","San Juan de la Costa","San Pablo"],
    AI: ["Aysén","Chile Chico","Cisnes","Cochrane","Coyhaique","Guaitecas","Lago Verde","O'Higgins","Río Ibáñez","Tortel"],
    MA: ["Antártica","Cabo de Hornos","Laguna Blanca","Natales","Porvenir","Primavera","Punta Arenas","Río Verde","San Gregorio","Timaukel","Torres del Paine"]
  };

  /* ---------------------------------------------------------------
     FALLBACK (si el fetch falla) — tramo 1 (hasta 0.5 kg) + ETA aprox
  --------------------------------------------------------------- */
  var FALLBACK = {
    RM: { price: 3490, days: [0, 0] },   // same-day
    VS: { price: 4403, days: [1, 2] },
    LI: { price: 4403, days: [1, 2] },
    CO: { price: 4284, days: [2, 3] },
    ML: { price: 4641, days: [2, 3] },
    NB: { price: 5117, days: [2, 3] },
    BI: { price: 5117, days: [2, 3] },
    AR: { price: 5593, days: [3, 4] },
    LR: { price: 5950, days: [3, 4] },
    LL: { price: 5831, days: [3, 4] },
    AT: { price: 4760, days: [3, 4] },
    AN: { price: 6664, days: [3, 4] },
    TA: { price: 5831, days: [4, 6] },
    AP: { price: 6188, days: [4, 6] },
    AI: { price: 7735, days: [5, 8] },
    MA: { price: 7735, days: [5, 8] }
  };

  var DOW = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  var MON = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];

  /* ---------------------------------------------------------------
     UTILIDADES
  --------------------------------------------------------------- */
  function $(id) { return document.getElementById(id); }

  // $3.490 (miles con punto, formato chileno)
  function fmtCLP(n) {
    return "$" + Math.round(Number(n) || 0).toLocaleString("es-CL");
  }

  function sortEs(arr) {
    return arr.slice().sort(function (a, b) { return a.localeCompare(b, "es"); });
  }

  function addBusinessDays(start, n) {
    var d = new Date(start);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function friendlyDate(d) {
    return DOW[d.getDay()] + " " + d.getDate() + " " + MON[d.getMonth()];
  }

  // ETA legible a partir del rango de días [min,max]
  function etaFromDays(days) {
    var now = new Date();
    if (days[0] === 0) {
      var beforeNoon = now.getHours() < 12;
      return {
        text: beforeNoon
          ? "Llega hoy entre 12:00 y 22:00 hrs"
          : "Llega mañana entre 12:00 y 22:00 hrs",
        sameDay: beforeNoon
      };
    }
    var d1 = addBusinessDays(now, days[0]);
    var d2 = addBusinessDays(now, days[1]);
    var text = (days[0] === days[1])
      ? "Llega el " + friendlyDate(d1)
      : "Llega entre el " + friendlyDate(d1) + " y el " + friendlyDate(d2);
    return { text: text, sameDay: false };
  }

  /* ---------------------------------------------------------------
     LOCALSTORAGE (con fallback a memoria si está bloqueado)
  --------------------------------------------------------------- */
  var memStore = null;
  function saveState(obj) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(obj)); }
    catch (e) { memStore = obj; }
  }
  function loadState() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { /* ignore */ }
    return memStore;
  }

  /* ---------------------------------------------------------------
     LLAMADA AL CARRIERSERVICE (Daffl)
  --------------------------------------------------------------- */
  function fetchRates(provinceCode, comuna) {
    // Daffl no valida algunos nombres oficiales → enviar el nombre que su
    // sistema reconoce (verificado contra su API el 22-07-2026). Sin esto
    // responde "NO SE PUDO VALIDAR" con tarifa fallback cara y errónea.
    var COMUNA_ALIAS = {
      "La Calera": "Calera",     // VS: oficial "La Calera", Daffl usa "Calera"
      "Marchihue": "Marchigüe",  // LI: grafía alternativa que Daffl valida
      "Pelequén": "Malloa"       // LI: localidad de Malloa; Daffl tarifica Malloa
    };
    var comunaDaffl = COMUNA_ALIAS[comuna] || comuna;
    var body = {
      rate: {
        origin: {
          country: "CL", province: "RM", city: "Vitacura",
          postal_code: "7630000", address1: "Alonso de Córdova 4212",
          address2: "Local 2B", phone: "", name: "The Fuel Place"
        },
        destination: {
          country: "CL", province: provinceCode, city: comunaDaffl,
          postal_code: "", address1: "", address2: "", phone: "", name: ""
        },
        items: [{
          name: "Producto", quantity: 1, grams: 300, price: 2000000,
          vendor: "The Fuel Place", requires_shipping: true, sku: "",
          product_id: 1, variant_id: 1
        }],
        currency: "CLP", locale: "es-CL"
      }
    };

    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

    return fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Shop-Domain": SHOP_DOMAIN   // obligatorio (sin esto da 500)
      },
      body: JSON.stringify(body),
      signal: controller.signal
    }).then(function (res) {
      clearTimeout(timer);
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    }).then(function (data) {
      var rates = (data && data.rates) ? data.rates : [];
      if (!rates.length) throw new Error("Sin tarifas");
      return rates;
    });
  }

  // Separa las tarifas de despacho (1 o 2: estándar y/o priority) de la de retiro (PICKUP)
  function parseRates(rates, provinceCode) {
    var COURIER_NAMES = { "BLP": "Bluexpress", "BLE": "Bluexpress" };
    var despachos = [], retiro = null;

    for (var i = 0; i < rates.length; i++) {
      var r = rates[i];
      var code = (r.service_code || "").toUpperCase();
      if (code.indexOf("PICKUP") !== -1) { retiro = r; continue; }

      var name = r.service_name || "";
      // Precio: total_price viene en CENTÉSIMOS → /100
      var price = Math.round((Number(r.total_price) || 0) / 100);

      // Courier: 4º campo del service_code ("DAFFL-STANDARD-SHIPPING|min|max|courier|id")
      var courier = "";
      var parts = (r.service_code || "").split("|");
      if (parts.length >= 4 && parts[3]) courier = parts[3].trim();
      if (COURIER_NAMES[courier]) courier = COURIER_NAMES[courier];

      // Same-day: solo si el nombre dice "recibe HOY" (no basta "Compra hoy y recibe MAÑANA")
      var sameDay = /recibe\s+hoy/i.test(name);
      var eta = (r.description || "").trim();
      if (!eta) {
        var fb = FALLBACK[provinceCode];
        eta = fb ? etaFromDays(fb.days).text : "";
        if (sameDay) eta = etaFromDays([0, 0]).text;
      }

      var isPriority = /priority/i.test(name);
      despachos.push({
        price: price, courier: courier, eta: eta,
        sameDay: sameDay, priority: isPriority, label: ""
      });
    }
    if (!despachos.length) throw new Error("Sin despacho");

    // Más barato primero; etiquetas según cantidad
    despachos.sort(function (a, b) { return a.price - b.price; });
    for (var j = 0; j < despachos.length; j++) {
      var d = despachos[j];
      d.label = (despachos.length > 1)
        ? (d.priority ? "Despacho Priority" : "Despacho Estándar")
        : "Despacho a domicilio";
    }

    return { despachos: despachos, isFallback: false };
  }

  // Resultado desde la tabla de fallback
  function fallbackResult(provinceCode) {
    var fb = FALLBACK[provinceCode];
    if (!fb) fb = { price: 0, days: [3, 5] };
    var eta = etaFromDays(fb.days);
    return {
      despachos: [{
        price: fb.price,
        courier: "Despacho estándar",
        eta: eta.text,
        sameDay: eta.sameDay,
        priority: false,
        label: "Despacho a domicilio"
      }],
      isFallback: true
    };
  }

  /* ---------------------------------------------------------------
     RENDER
  --------------------------------------------------------------- */
  function poblarRegiones() {
    var sel = $("tfp-region");
    // RM siempre primera; el resto en orden alfabético A–Z (locale es)
    var rm = REGIONS.filter(function (r) { return r.code === "RM"; });
    var rest = REGIONS.filter(function (r) { return r.code !== "RM"; })
      .sort(function (a, b) { return a.name.localeCompare(b.name, "es"); });
    rm.concat(rest).forEach(function (r) {
      var o = document.createElement("option");
      o.value = r.code;
      o.textContent = r.name;
      sel.appendChild(o);
    });
  }

  function poblarComunas(regionCode, preselect) {
    var sel = $("tfp-comuna");
    sel.innerHTML = '<option value="" selected disabled>Elige tu comuna</option>';
    var list = sortEs(COMUNAS[regionCode] || []);
    list.forEach(function (c) {
      var o = document.createElement("option");
      o.value = c;
      o.textContent = c;
      if (preselect && c === preselect) o.selected = true;
      sel.appendChild(o);
    });
    sel.disabled = false;
  }

  var BADGE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.2"/><path d="M12 7.5v4.8l3 1.8"/></svg>';

  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5h11.5v8.2H3z"/><path d="M14.5 10.2h3.6l2.9 2.9v2.6h-6.5z"/><circle cx="7" cy="17.6" r="1.7"/><circle cx="17.2" cy="17.6" r="1.7"/></svg>';
  var ICON_BOLT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2.5 4.5 13.5h6L11 21.5l8.5-11h-6z"/></svg>';

  function buildDespachoRow(d) {
    var row = document.createElement("div");
    row.className = "tfp-row";

    var icon = document.createElement("span");
    icon.className = "tfp-row__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = d.priority ? ICON_BOLT : ICON_TRUCK;

    var text = document.createElement("div");
    text.className = "tfp-row__text";
    var title = document.createElement("div");
    title.className = "tfp-row__title";
    title.textContent = d.label;
    text.appendChild(title);
    if (d.eta) {
      var sub1 = document.createElement("div");
      sub1.className = "tfp-row__sub";
      sub1.textContent = d.eta;
      text.appendChild(sub1);
    }
    if (d.courier) {
      var sub2 = document.createElement("div");
      sub2.className = "tfp-row__sub";
      sub2.textContent = d.courier;
      text.appendChild(sub2);
    }

    var price = document.createElement("div");
    price.className = "tfp-row__price";
    price.textContent = fmtCLP(d.price);

    row.appendChild(icon);
    row.appendChild(text);
    row.appendChild(price);
    return row;
  }

  function renderResult(res) {
    var flags = $("tfp-result-flags");
    flags.innerHTML = "";

    // "Recibe hoy" solo si alguna opción es same-day y su ETA realmente dice "hoy"
    var llegaHoy = false;
    for (var i = 0; i < res.despachos.length; i++) {
      var d = res.despachos[i];
      if (d.sameDay && /\bhoy\b/i.test(d.eta || "")) { llegaHoy = true; break; }
    }
    if (llegaHoy) {
      var b = document.createElement("span");
      b.className = "tfp-badge";
      b.innerHTML = BADGE_ICON + "Recibe hoy";
      flags.appendChild(b);
    }
    if (res.isFallback) {
      var ref = document.createElement("span");
      ref.className = "tfp-ref";
      ref.textContent = "Tarifa de referencia";
      flags.appendChild(ref);
    }

    var cont = $("tfp-ship-despachos");
    cont.innerHTML = "";
    for (var j = 0; j < res.despachos.length; j++) {
      cont.appendChild(buildDespachoRow(res.despachos[j]));
    }

    $("tfp-ship-result").classList.add("is-shown");
  }

  function updateTrigger(comuna, price, multi) {
    var triggers = document.querySelectorAll(".tfp-ship-trigger");
    Array.prototype.forEach.call(triggers, function (t) {
      var lbl = t.querySelector(".tfp-ship-trigger__lbl");
      var val = t.querySelector(".tfp-ship-trigger__value");
      if (lbl) lbl.textContent = "Despacho a";
      if (val) val.textContent = comuna + " · " + (multi ? "desde " : "") + fmtCLP(price);
    });
  }

  /* ---------------------------------------------------------------
     MODAL open / close
  --------------------------------------------------------------- */
  var backdrop, lastFocus = null;

  function openModal() {
    lastFocus = document.activeElement;
    backdrop.hidden = false;
    backdrop.classList.add("is-open");
    document.body.style.overflow = "hidden";
    document.body.classList.add("tfp-ship-modal-open");
    document.addEventListener("keydown", onKey);
    var sel = $("tfp-region");
    setTimeout(function () { if (sel) sel.focus(); }, 50);
  }
  function closeModal() {
    backdrop.classList.remove("is-open");
    backdrop.hidden = true;
    document.body.style.overflow = "";
    document.body.classList.remove("tfp-ship-modal-open");
    document.removeEventListener("keydown", onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === "Escape") closeModal(); }

  /* ---------------------------------------------------------------
     CÁLCULO
  --------------------------------------------------------------- */
  function calcular() {
    var region = $("tfp-region").value;
    var comuna = $("tfp-comuna").value;
    if (!region || !comuna) return;

    var btn = $("tfp-ship-calc");
    var btnText = $("tfp-calc-text");
    var errEl = $("tfp-ship-error");
    errEl.classList.remove("is-shown");
    $("tfp-ship-result").classList.remove("is-shown");

    btn.disabled = true;
    btn.classList.add("is-loading");
    btnText.textContent = "Calculando…";

    function finish(res) {
      btn.classList.remove("is-loading");
      btn.disabled = false;
      btnText.textContent = "Calcular despacho";
      renderResult(res);
      var minPrice = res.despachos[0].price;   // ya vienen ordenados asc
      var multi = res.despachos.length > 1;
      updateTrigger(comuna, minPrice, multi);
      saveState({ region: region, comuna: comuna, price: minPrice, multi: multi });
    }

    fetchRates(region, comuna)
      .then(function (rates) { finish(parseRates(rates, region)); })
      .catch(function () { finish(fallbackResult(region)); });   // timeout / error → fallback
  }

  /* ---------------------------------------------------------------
     INIT — tolera que trigger y modal estén en partes distintas del DOM
  --------------------------------------------------------------- */
  function init() {
    backdrop = $("tfp-ship-modal");
    var triggers = document.querySelectorAll(".tfp-ship-trigger");

    // Si falta el modal, no hacemos nada (evita errores en páginas sin el snippet)
    if (!backdrop) return;

    // Portal: sacar el modal del stacking context de la sección sticky (z-index 999)
    // y colgarlo del <body>, para que su z-index quede por encima del header (1000).
    // Sin esto, en mobile el header tapa la parte superior del modal (la "X" de cerrar).
    if (backdrop.parentNode !== document.body) {
      document.body.appendChild(backdrop);
    }

    poblarRegiones();

    var regionSel = $("tfp-region");
    var comunaSel = $("tfp-comuna");
    var calcBtn = $("tfp-ship-calc");
    var closeBtn = $("tfp-ship-close");

    regionSel.addEventListener("change", function () {
      poblarComunas(regionSel.value);
      calcBtn.disabled = true;
      $("tfp-ship-result").classList.remove("is-shown");
    });

    comunaSel.addEventListener("change", function () {
      calcBtn.disabled = !comunaSel.value;
    });

    calcBtn.addEventListener("click", calcular);

    Array.prototype.forEach.call(triggers, function (t) { t.addEventListener("click", openModal); });
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    backdrop.addEventListener("click", function (e) {
      if (e.target === backdrop) closeModal();
    });

    // Restaurar última selección guardada → el trigger ya muestra la comuna
    var st = loadState();
    if (st && st.region && st.comuna) {
      regionSel.value = st.region;
      poblarComunas(st.region, st.comuna);
      calcBtn.disabled = false;
      if (typeof st.price === "number") updateTrigger(st.comuna, st.price, !!st.multi);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
